import React, { useState, useMemo, useContext } from 'react';
import ManageAccountGrid from '../../../../managementAccount/manageAccountGrid/index';
import DialogComp from '../../../../../Core/Modal/dialogModal';
import { EditButton } from '../../../../../Core/FormInput/inputfields';
import DashboardAddUpdateModal from './dashboardAddUpdateModal';
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton, Tooltip } from '@material-ui/core';
import { postMADashboardCategory_Delete } from '../../../../../Core/Service/ManageAccount/maDashboard-Category-service';
import AppContext from '../../../../../App/AppContext';
import ConfirmationModal from '../../../../../Core/Controls/Dialog/ConfirmationModal';

const basecolumns = [
    { field: 'action', title: 'Action', width: 60 },
    { field: 'maDashboardCategoryName', title: 'Category Name', width: 180 },
    { field: 'maDashboardActualName', title: 'Actual Name', width: 180 },
    { field: 'maDashboardBudgetName', title: 'Budget Name', width: 180 },
    { field: 'maDashboardVarianceName', title: 'Variance Name', width: 200 },
    { field: 'maDashboardKPIsName', title: 'KPIs Name', width: 200 },
    { field: 'maDashboardSequence', title: 'Sequence No.', width: 100 }
];

const DashboardCategory = ({ dashboardData, onClose }) => {
    const { showToast } = useContext(AppContext);
    const [state, setState] = useState({
        showLoader: true,
        selectedRowData: {},
        modalOpen: false,
        isAdd: false,
        title: ''
    });

    const removeCategory = async (data) => {
        let res = await postMADashboardCategory_Delete(state.selectedRowData.maDashboardCategoryId);
        if (res.success) {
            showToast('Category Deleted Successfully', 'success');
            setState((st) => ({
                ...st,
                isReload: new Date(),
                showWarning: false
            }));
        }
    };

    const showDeleteHandle = (data) => {
        setState((st) => ({
            ...st,
            selectedRowData: data,
            showWarning: true
        }));
    };
    const hideConfirmationModal = (data) => {
        setState((st) => ({
            ...st,
            selectedRowData: {},
            showWarning: false
        }));
    };

    const renderEdit = (ev, row) => {
        return (
            <div style={{ textAlign: 'center', cursor: 'pointer' }}>
                <EditButton
                    toolTipTitle="Update Category"
                    onClick={() => {
                        setState((st) => ({
                            ...st,
                            modalOpen: true,
                            title: 'Update Category',
                            selectedRowData: row,
                            isAdd: false
                        }));
                    }}
                />
                <Tooltip title="Delete Category">
                    {/* <IconButton */}
                    {/* // onClick={props.RemoveImage} */}
                    {/* > */}
                    <DeleteIcon color="secondary" onClick={() => showDeleteHandle(row)} />
                    {/* </IconButton> */}
                </Tooltip>
            </div>
        );
    };

    const addBtnClicked = () => {
        setState((st) => ({
            ...st,
            modalOpen: true,
            title: 'Add Category',
            isAdd: true,
            selectedRowData: {}
        }));
    };

    const handleCloseModal = (isReload = false) => {
        setState((st) => ({
            ...st,
            modalOpen: false,
            selectedRowData: {},
            isReload: isReload ? new Date() : st.isReload
        }));
    };

    const columns = useMemo(() => {
        const tempCols = [...basecolumns];
        let actionCol = tempCols.find((e) => e.field === 'action');
        if (actionCol) {
            actionCol.renderer = renderEdit;
        }
        return tempCols;
    }, []);

    return (
        <div className="report-screen-container">
            <ManageAccountGrid
                columns={columns}
                getUrl={`MADashboardCategory?mADashboardID=${dashboardData?.maDashboardID}`}
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                isReload={state.isReload}
                btnTitle="Add"
                onBtnClick={addBtnClicked}
            />
            {state.modalOpen && (
                <DialogComp
                    title={state.title}
                    onClose={() => handleCloseModal()}
                    // maxWidth="xl"
                    fullScreen
                    fullWidth
                    overflow
                >
                    <DashboardAddUpdateModal
                        onClose={handleCloseModal}
                        selectedRowData={state.selectedRowData}
                        isAdd={state.isAdd}
                        dashboardData={dashboardData}
                    />
                </DialogComp>
            )}
            {state.showWarning ? (
                <DialogComp title="Warning" onClose={hideConfirmationModal} maxWidth="sm" fullWidth>
                    <ConfirmationModal
                        message={`Are You sure you want to remove - ${state.selectedRowData.maDashboardCategoryName}`}
                        handleSubmit={removeCategory}
                        handleCancel={hideConfirmationModal}
                    />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default DashboardCategory;
